import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class XivaConnectionTimeoutError extends BaseError {
    constructor(loggerFields: SafeLogErrorOptions, stack?: string) {
        super(
            'Xiva connection timeout',
            {
                source: 'backend',
                ...loggerFields,
            },
            stack
        );

        Object.setPrototypeOf(this, XivaConnectionTimeoutError.prototype);
    }
}
